var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 12.1832C19.9997 11.6394 19.9547 11.0926 19.8588 10.5576H12.1602V13.6383H16.5688C16.3858 14.6318 15.798 15.5108 14.9373 16.0693V18.0682H17.5675C19.112 16.6748 19.9997 14.6171 19.9997 12.1832Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1609 19.9992C14.3622 19.9992 16.2186 19.2908 17.5712 18.068L14.941 16.0691C14.2093 16.557 13.2646 16.8333 12.1639 16.8333C10.0346 16.8333 8.22914 15.4253 7.58134 13.5322H4.86719V15.5929C6.25275 18.2943 9.07487 19.9992 12.1609 19.9992Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57743 13.5328C7.23554 12.5393 7.23554 11.4634 7.57743 10.4698V8.40918H4.86628C3.70864 10.6697 3.70864 13.3329 4.86628 15.5935L7.57743 13.5328Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1609 7.16546C13.3245 7.14783 14.4492 7.577 15.2919 8.3648L17.6222 6.08077C16.1467 4.72269 14.1883 3.97605 12.1609 3.99956C9.07487 3.99956 6.25275 5.7045 4.86719 8.4089L7.57834 10.4695C8.22314 8.57351 10.0316 7.16546 12.1609 7.16546Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.d61575401474ef117f56ece8f57db3f8.svg";
export { ForwardRef as ReactComponent };